__webpack_public_path__ =  appConfig.reactStaticFilePathNsa ||'//scache-ws.vzw.com/e/imageFiles/intl/nsa/';
